const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validateForm = async (state) => {
    let firstError;
    let validationSuccess = true;
    let validationMessage = {};

    if (!state.newEmail) {
        validationMessage.newEmail = "changeEmail.validation.newEmail";
        if (!firstError) firstError = "newEmail";
        validationSuccess = false;
    } else {
        if (!validateEmail(state.newEmail)) {
            validationMessage.newEmail = "changeEmail.validation.newEmailInvalid";
            if (!firstError) firstError = "newEmail";
            validationSuccess = false;
        }
    }

    if (state.confirmNewEmail !== state.newEmail) {
        validationMessage.confirmNewEmail = "changeEmail.validation.confirmNewEmailNotMatch";
        if (!firstError) firstError = "confirmNewEmail";
        validationSuccess = false;
    }

    return { validationSuccess, firstError, validationMessage };
};

export { validateForm, validateEmail, isValidEmail };